<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/planningteam/storeDynamic/${inputs.id}`
            : `/accreditationtechnical/planningteam/storeDynamic/`
        "
      >
        <div class="my-2">
          <div class="col-sm" v-if="evaluationType=='E'">
            <div class="card">
              <div class="card-header d-sm-flex justify-content-sm-left">
                <div>
                  <h5>Evaluador Líder</h5>
                </div>
              </div>
              <div class="card-body">
                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("Evaluador lider") }}
                  </label>
                  <app-input
                    id="inputs_name"
                    class="col-sm-9"
                    type="search-select"
                    v-model="inputs.evaluator_id"
                    :list="evaluatorsLiderList"
                    :required="true"
                  />
                </div>

                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    Datos procedentes
                  </label>
                  <app-input
                    type="textarea"
                    class="col-sm-9"
                    v-model="inputs.provenance"
                    placeholder="Ingrese: SAE o Externo, Nombre de la entidad donde labora, si es privada o pública, Aplica o no convenio"
                    :required="true"
                  />
                </div>

                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    Número total de días
                  </label>
                  <app-input
                    type="number"
                    class="col-sm-9"
                    v-model="inputs.number_days"
                    placeholder="Ingrese total de días"
                    :required="true"
                  />
                </div>

                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    Observaciones
                  </label>
                  <app-input
                    type="textarea"
                    class="col-sm-9"
                    v-model="inputs.observations"
                    placeholder="Ingrese observaciones"
                    :required="true"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm">
            <hr />
            <legend class="col-12 row text-primary pt-0 mb-3">
              <h5>Evaluadores</h5>
            </legend>
            <dynamic-form
              titleva="Evaluador"
              self="profiles"
              :model="evaluators"
              :evaluatorList="evaluatorList"
              :evaluationTeam="evaluationTeam"
            />

            <hr />
            <legend class="col-12 row text-primary pt-0 mb-3">
              <h5>Evaluadores en entrenamiento</h5>
            </legend>
            <dynamic-form-eva-ent
              titleva="E. entrenamiento"
              self="profiles"
              :model="trainings"
              :evaluatorsTrainingList="evaluatorsTrainingList"
              :evaluationTeam="evaluationTeam"
            />
            <div v-if="evaluationType=='E'">
              <hr />
              <legend class="col-12 row text-primary pt-0 mb-3">
                <h5>Evaluadores lider en entrenamiento</h5>
              </legend>
              <dynamic-form-lider-ent
                titleva="E. lider en entrenamiento"
                self="profiles"
                :model="lider_trainings"
                :liderEvaluatorTrainingList="liderEvaluatorTrainingList"
                :evaluationTeam="evaluationTeam"
              />
            </div>

            <hr />
            <legend class="col-12 row text-primary pt-0 mb-3">
              <h5>Expertos técnicos</h5>
            </legend>
            <dynamic-form-exp
              titleva="Experto técnico"
              self="profiles"
              :model="experts"
              :technicalExpertList="technicalExpertList"
              :evaluationTeam="evaluationTeam"
            />

            <hr />
            <legend class="col-12 row text-primary pt-0 mb-3">
              <h5>Observadores</h5>
            </legend>
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Observadores") }}
              </label>
              <app-input
                class="col-sm-9"
                type="multi-select"
                :list="observerList"
                :isAnimatedDropdown="true"
                v-model="observer"
              />
            </div>
            <div class="row w-100 justify-content-end">
              <a
                :href="`/observer/maintenance`"
                target="_blank"
                class="d-flex justify"
                >Añadir observador</a
              >
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "@/app/helpers/AxiosHelper";
import DynamicForm from "./dynamic/DynamicForm";
import DynamicFormExp from "./dynamic/DynamicFormExp";
import DynamicFormEvaEnt from "./dynamic/DynamicFormEvaEnt";
import DynamicFormLiderEnt from "./dynamic/DynamicFormLiderEnt";

export default {
  name: "ModalEvaluators",
  mixins: [FormMixin, ModalMixin],
  components: {
    quillEditor,
    DynamicForm,
    DynamicFormExp,
    DynamicFormEvaEnt,
    DynamicFormLiderEnt,
  },
  props: {
    tableId: String,
    modalTitle: String,
    evaluatorsLiderList: Array,
    evaluatorList: Array,
    evaluatorsTrainingList: Array,
    liderEvaluatorTrainingList: Array,
    technicalExpertList: Array,
    observerList: Array,
    evaluationId: String,
    evaluationTeam: Object,
    evaluationType: String,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      modalId: "modal-evaluator-edit",
      evaluators: {},
      experts: {},
      trainings: {},
      lider_trainings: {},
      observer: [],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
    this.checkDataEvaluation();
  },
  methods: {
    submit() {
      var request = {};
      request["id"] = this.evaluationId;
      request["color"] = "#1CA085";
      request["inputs"] = this.inputs;
      request["evaluators"] = this.evaluators;
      request["trainings"] = this.trainings;
      request["lider_trainings"] = this.lider_trainings;
      request["experts"] = this.experts;
      request["observer"] = this.observer;
      this.save(request);
    },

     afterSuccess(response) {
      this.$toastr.s(response.data.message);
    },

    afterError(response) {
      this.$toastr.e(response.data.message);
    },
    checkDataEvaluation() {
      
      if (this.evaluationTeam.lider.length > 0 ){
        this.inputs = {
          evaluator_id: this.evaluationTeam.lider[0].evaluator_id,
          provenance: this.evaluationTeam.lider[0].provenance,
          number_days: this.evaluationTeam.lider[0].number_days,
          observations: this.evaluationTeam.lider[0].observations,
        };
      }

      if (this.evaluationTeam.observer.length > 0) {
        this.observer = this.evaluationTeam.observer;
      }
    }
  },

};
</script>
<style>
.color-req {
  color: red;
}

.space {
  margin-top: 100px;
}
</style>
